export default __webpack_public_path__ + "static/media/a017-e.13a02eb0.svg";